


























import { computed, defineComponent, PropType, watch } from "@vue/composition-api";
import { $t } from "@/lib/i18nHelpers";
import { BaseMenuItem } from "@/types";
import BaseIcon from "@/components/Base/BaseIcon";
import BaseIconButton from "@/components/BaseIconButton";
import BaseMenu from "@/components/BaseMenu";
import BaseSpinner from "@/components/BaseSpinner";
import { ProfileFeedFiltersType } from "@/views/PageProfile/types";

export default defineComponent({
  name: "ProfileFeedFilters",
  components: { BaseSpinner, BaseIconButton, BaseIcon, BaseMenu },
  props: {
    activeFilterType: { type: String as PropType<ProfileFeedFiltersType>, default: null },
    isFeedView: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    isAuthor: { type: Boolean, default: false },
    isProfileCreator: { type: Boolean, default: false },
    isProfileFullCreator: { type: Boolean, default: false },
  },
  setup(props, { emit }) {
    const getActiveClass = (type: ProfileFeedFiltersType) => {
      return props.activeFilterType === type ? "__active" : "";
    };

    const filterItems = computed<BaseMenuItem[]>(() => {
      return [
        ...(!props.isAuthor && props.isProfileFullCreator
          ? [
              {
                text: $t("Creator’s videos"),
                name: ProfileFeedFiltersType.CREATOR_VIDEOS,
                class: getActiveClass(ProfileFeedFiltersType.CREATOR_VIDEOS),
              },
            ]
          : []),
        ...(props.isAuthor && props.isProfileFullCreator
          ? [
              {
                text: $t("My videos"),
                name: ProfileFeedFiltersType.MY_VIDEOS,
                class: getActiveClass(ProfileFeedFiltersType.MY_VIDEOS),
              },
            ]
          : []),
        ...(props.isProfileFullCreator || props.isProfileCreator
          ? [
              {
                text: $t("Featured in"),
                name: ProfileFeedFiltersType.FEATURED_IN,
                class: getActiveClass(ProfileFeedFiltersType.FEATURED_IN),
              },
            ]
          : []),
        ...(props.isAuthor && (props.isProfileCreator || props.isProfileFullCreator)
          ? [
              {
                text: $t("Awaiting approval"),
                name: ProfileFeedFiltersType.AWAITING_APPROVAL,
                class: getActiveClass(ProfileFeedFiltersType.AWAITING_APPROVAL),
              },
            ]
          : []),
      ];
    });

    const activeFilter = computed(
      () => filterItems.value.find(i => i.name === props.activeFilterType) || filterItems.value[0]
    );

    watch(
      [activeFilter, filterItems],
      () => {
        if (!activeFilter.value) return;
        if (!filterItems.value.find(i => i.name === props.activeFilterType)) {
          emit("updateFilter", activeFilter.value.name);
        }
      },
      { immediate: true }
    );

    const onSubmitFilter = (name: ProfileFeedFiltersType) => {
      if (name === props.activeFilterType) return;
      emit("updateFilter", name);
    };

    return { filterItems, activeFilter, onSubmitFilter };
  },
});
